import React from 'react';
import { Button, Dialog } from '@material-ui/core';
import i18n from '../../i18n';
import './store-upgrade-dialog.style.scss';

type Props = {
    visible: boolean;
    onExperience: () => void;
    /** restaurant：餐厅主页；reservations：预定页 */
    variant?: 'restaurant' | 'reservations';
};

const COPY_KEYS = {
    restaurant: {
        title: 'store_upgrade_title',
        content: 'store_upgrade_content',
        button: 'store_upgrade_button'
    },
    reservations: {
        title: 'store_upgrade_reservation_title',
        content: 'store_upgrade_reservation_content',
        button: 'store_upgrade_reservation_button'
    }
} as const;

/**
 * 店铺升级引导：跳转新 OD（不可关闭，仅主按钮）
 */
export function StoreUpgradeDialog({ visible, onExperience, variant = 'restaurant' }: Props) {
    const keys = COPY_KEYS[variant];
    return (
        <Dialog
            className='storeUpgradeDialog'
            open={visible}
            onClose={() => { /* 禁止遮罩 / ESC 关闭，由 disable* 拦截 */ }}
            disableBackdropClick
            disableEscapeKeyDown
            fullWidth
        >
            <div className='store-upgrade-dialog-head'>
                <span className='store-upgrade-dialog-title'>
                    {i18n.t(keys.title)}
                </span>
            </div>
            <div className='store-upgrade-dialog-body'>
                <p className='store-upgrade-dialog-content'>{i18n.t(keys.content)}</p>
                <div className='store-upgrade-dialog-actions'>
                    <Button
                        className='store-upgrade-dialog-btn'
                        onClick={() => { onExperience(); }}
                    >
                        {i18n.t(keys.button)}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
}
